module.exports = __webpack_public_path__ + "img/default_image.3afa677e.png";